:host {
  display: contents;
}

.flyoutmenu-container {
  & .flyoutmenu-wrapper {
    min-width: 200px;
  }

  .flyoutmenu-user-container {
    @apply grid;
    grid-template-columns: 80px 1fr;
    padding: 12px 6px 0 6px;

    .flyoutmenu-avatar-container {
      @apply flex items-center justify-center w-[80px] h-[80px];
    }

    .flyoutmenu-user-name {
      @apply font-button text-copy;
    }

    .flyoutmenu-user-info {
      @apply font-text text-copy-small;
    }

    span {
      @apply overflow-hidden;
      text-overflow: ellipsis;
    }
  }
}
